// extracted by mini-css-extract-plugin
module.exports = {"neutralAttachment":"Calendar-module__neutralAttachment___4AN-L","loadingAttachment":"Calendar-module__loadingAttachment___2bUZA"};